import { Option } from 'lib/components/dropdown/Dropdown.vue.d';

const filterOptions = (options?: Option[] | string[]): Option[] | string[] => {
  if (!options?.length) return [];

  if (typeof options?.[0] === 'string') {
    return options as string[];
  }
  return (options as Option[])?.filter((option) => option.visible !== false);
};

export default filterOptions;
